/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_9_P1Inputs */

const en_terms_section_9_p1 = /** @type {(inputs: Terms_Section_9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To the fullest extent the law of the Republic of Latvia allows, Lindevo is not liable for indirect, incidental, special, consequential or punitive damages arising from your use of, or inability to use, this website or our services.`)
};

const lv_terms_section_9_p1 = /** @type {(inputs: Terms_Section_9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciktāl to pieļauj Latvijas Republikas likumi, Lindevo neatbild par netiešiem, nejaušiem, īpašiem, izrietošiem vai sodošiem zaudējumiem, kas radušies, lietojot šo tīmekļvietni vai mūsu pakalpojumus vai nespējot tos lietot.`)
};

/**
* | output |
* | --- |
* | "To the fullest extent the law of the Republic of Latvia allows, Lindevo is not liable for indirect, incidental, special, consequential or punitive damages ar..." |
*
* @param {Terms_Section_9_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_9_p1 = /** @type {((inputs?: Terms_Section_9_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_9_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_9_p1(inputs)
	return en_terms_section_9_p1(inputs)
});